module.exports = __webpack_public_path__ + "static/zpc400-e3accf7aa936208f43c554aa50790616.png";